import "./ApplicationForm.css";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import axios from "../axios";
import Spinner from "../Images/spinner-removebg-preview.png";
import Done from "../Images/right.png";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

function ApplicationForm() {
  const [confirmationComponentPayment, setConfirmationComponentPayment] =
    useState(false);
  const [loginError, setLoginError] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [amount, setAmount] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [proofOfPayment, setProofOfPayment] = useState("");
  const [formPage, setFormPage] = useState("initial");
  const [confirmationComponentPersonal, setConfirmationComponentPersonal] =
    useState(false);
  const [name, setName] = useState("");
  const [motherName, setMotherName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [socialCategory, setSocialCategory] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [photo, setPhoto] = useState("");
  const [signature, setSignature] = useState("");
  const [emailId, setEmailId] = useState("");
  const [permanentAddress, setPermanentAddress] = useState("");
  const [collegeList, setCollegeList] = useState(true);
  const [
    confirmationComponentEducational,
    setConfirmationComponentEducational,
  ] = useState(false);
  const [subject, setSubject] = useState("");
  const [college, setCollege] = useState(
    "University College, Kakatiya University, Warangal."
  );
  const [faculty, setFaculty] = useState("");
  const [degree, setDegree] = useState("");
  const [universityName, setUniversityName] = useState("");
  const [yearOfPassing, setYearOfPassing] = useState("");
  const [supervisorName, setSupervisorName] = useState("");
  const [titleOfThesis, setTitleOfThesis] = useState("");
  const [yearOfAdmission, setYearOfAdmission] = useState("");
  const [admOrder, setAdmOrder] = useState("");
  const [supervisorCert, setSupervisorCert] = useState("");
  const [joiningReport, setJoiningReport] = useState("");
  const [researchPaper, setResearchPaper] = useState("");
  const [synopsis, setSynopsis] = useState("");
  const [thesis, setThesis] = useState("");
  const [seminar1, setSeminar1] = useState("");
  const [seminar2, setSeminar2] = useState("");
  const [noDue, setNoDue] = useState("");
  const [fullOrPartTime, setFullOrPartTime] = useState("");
  const [withInTime, setWithInTime] = useState("");
  const [takenPermission, setTakenPermission] = useState("No");
  const [permissionOrder, setPermissionOrder] = useState("");
  const [prePhdMemo, setPrePhdMemo] = useState("");
  const [prePhdPassMonthYear, setPrePhdPassMonthYear] = useState("");

  setInterval(() => {
    if (!Cookies.get("userInfo")) {
      logout();
    }
  }, 1000);
  useEffect(() => {
    async function fetchData() {
      try {
        var reqData = {
          mobile: Cookies.get("username"),
        };
        const resData = await axios.post(
          "/api/get-application-details",
          reqData
        );
        if (resData.status === 200) {
          const data = resData.data;
          setFormPage(data.application_status);
        }
      } catch (e) {
        window.location.href = "/";
      }
    }
    fetchData();
  }, []);

  async function handleContinuePayment(event) {
    event.preventDefault();
    setConfirmationComponentPayment(true);
  }

  const handleEdit = () => {
    setConfirmationComponentPayment(false);
  };

  async function handleFileUploadForPayment(file) {
    let form_data = new FormData();
    form_data.append("file", file);
    form_data.append("file_name", "proof_of_payment");
    form_data.append("mobile", Cookies.get("username"));
    try {
      const resData = await axios.post("/api/file-upload", form_data);
      if (resData.status === 200) {
        setProofOfPayment(resData.data["file-name"]);
      }
    } catch (e) {
      console.log(e);
    }
  }

  const handleSubmitPayment = async () => {
    var reqData = {
      mobile: Cookies.get("username"),
      transaction_id: transactionId,
      transaction_amount: amount,
      date_of_payment: paymentDate,
      proof_of_payment: proofOfPayment,
    };
    try {
      const resData = await axios.post("/api/set-payment-details", reqData);
      if (resData.status === 201) {
        alert("payment details added succesfully");
        setFormPage("payment");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleEditPersonal = () => {
    setConfirmationComponentPersonal(false);
  };

  const handleContinuePersonal = (event) => {
    event.preventDefault();
    setConfirmationComponentPersonal(true);
  };

  async function handleFileUploadPersonal(file, file_name) {
    if (file_name === "photo") {
      setPhoto("load");
    } else if (file_name === "signature") {
      setSignature("load");
    }
    let form_data = new FormData();
    form_data.append("file", file);
    form_data.append("file_name", file_name);
    form_data.append("mobile", Cookies.get("username"));
    try {
      const resData = await axios.post("/api/file-upload", form_data);
      if (resData.status === 200) {
        if (file_name === "photo") {
          setPhoto(resData.data["file-name"]);
        } else if (file_name === "signature") {
          setSignature(resData.data["file-name"]);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  const handleSubmitPersonal = async () => {
    var reqData = {
      mobile: Cookies.get("username"),
      name,
      mother_name: motherName,
      father_name: fatherName,
      social_category: socialCategory,
      date_of_birth: dateOfBirth,
      email: emailId,
      permanent_address: permanentAddress,
      photo,
      signature,
    };
    try {
      const resData = await axios.post("/api/set-candidate-details", reqData);
      if (resData.status === 201) {
        alert("candidate details added succesfully");
        setFormPage("personal");
      } else {
        console.log(resData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleFullOrPartTime = (event) => {
    setFullOrPartTime(event.target.value);
  };

  const handleWithinTime = (event) => {
    setWithInTime(event.target.value);
    if (event.target.value === "Yes") {
      setPermissionOrder("");
      setTakenPermission("No");
    }
  };

  const handleTakenPermission = (event) => {
    setTakenPermission(event.target.value);
    if (event.target.value === "No") {
      setPermissionOrder("");
    }
  };

  const handleEditEducational = () => {
    setConfirmationComponentEducational(false);
  };

  const handleContinueEducational = (event) => {
    event.preventDefault();
    setConfirmationComponentEducational(true);
  };

  const testFileSize = (file) => {
    return true;
  };

  function permissionOrderFile(file) {
    setPermissionOrder("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setPermissionOrder("");
    } else {
      handleFileUploadEducational(file, "permission_order").then(
        (newFileName) => setPermissionOrder(newFileName)
      );
    }
  }
  function prePhdMemoFile(file) {
    setPrePhdMemo("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setPrePhdMemo("");
    } else {
      handleFileUploadEducational(file, "prephd_memo").then(
        (newFileName) => setPrePhdMemo(newFileName)
      );
    }
  }
  function admissionOrderFile(file) {
    setAdmOrder("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setAdmOrder("");
    } else {
      handleFileUploadEducational(file, "admission_order").then((newFileName) =>
        setAdmOrder(newFileName)
      );
    }
  }
  function supervisorCertFile(file) {
    setSupervisorCert("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setSupervisorCert("");
    } else {
      handleFileUploadEducational(file, "supervisor_certificate").then(
        (newFileName) => setSupervisorCert(newFileName)
      );
    }
  }
  function joiningReportFile(file) {
    setJoiningReport("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setJoiningReport("");
    } else {
      handleFileUploadEducational(file, "joining_report").then((newFileName) =>
        setJoiningReport(newFileName)
      );
    }
  }
  function researchPaperFile(file) {
    setResearchPaper("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setResearchPaper("");
    } else {
      handleFileUploadEducational(file, "reseacrch_paper").then((newFileName) =>
        setResearchPaper(newFileName)
      );
    }
  }
  function synopsisFile(file) {
    setSynopsis("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setSynopsis("");
    } else {
      handleFileUploadEducational(file, "synopsis").then((newFileName) =>
        setSynopsis(newFileName)
      );
    }
  }
  function thesisFile(file) {
    setThesis("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setThesis("");
    } else {
      handleFileUploadEducational(file, "thesis").then((newFileName) =>
        setThesis(newFileName)
      );
    }
  }
  function seminar1File(file) {
    setSeminar1("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setSeminar1("");
    } else {
      handleFileUploadEducational(file, "seminar_1").then((newFileName) =>
        setSeminar1(newFileName)
      );
    }
  }
  function seminar2File(file) {
    setSeminar2("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setSeminar2("");
    } else {
      handleFileUploadEducational(file, "seminar_2").then((newFileName) =>
        setSeminar2(newFileName)
      );
    }
  }
  function noDueFile(file) {
    setNoDue("load");
    if (testFileSize(file) !== true) {
      alert("file size should be ");
      setNoDue("");
    } else {
      handleFileUploadEducational(file, "no_due").then((newFileName) =>
        setNoDue(newFileName)
      );
    }
  }
  const handleFileUploadEducational = async (file, file_name) => {
    let form_data = new FormData();
    form_data.append("file", file);
    form_data.append("file_name", file_name);
    form_data.append("mobile", Cookies.get("username"));
    try {
      const resData = await axios.post("/api/file-upload", form_data);
      if (resData.status === 200) {
        console.log(resData.data["file-name"]);
        return resData.data["file-name"];
      } else {
        console.log(resData);
        return "";
      }
    } catch (e) {
      console.log(e);
      return "";
    }
  };

  const handleSubmitEducational = async () => {
    var reqData = {
      mobile: Cookies.get("username"),
      name_of_college: college,
      subject,
      faculty,
      degree,
      name_of_university: universityName,
      month_year_passing: yearOfPassing,
      name_of_Supervisour: supervisorName,
      title_of_thesis: titleOfThesis,
      admission_year_of_phd: yearOfAdmission,
      phd_admission_order: admOrder,
      supervisours_certificate: supervisorCert,
      joning_report: joiningReport,
      research_paper: researchPaper,
      synopsis,
      thesis,
      seminar1,
      seminar2,
      noDue,
      time: fullOrPartTime,
      withInTime,
      takenPermission,
      permissionOrder,
      prePhdMemo,
      pre_phd_passing_month_year: prePhdPassMonthYear,
    };
    try {
      const resData = await axios.post("/api/set-education-details", reqData);
      if (resData.status === 201) {
        alert("Education details added succesfully");
        setFormPage("submitted");
        window.location.href = "/status";
      } else {
        console.log(resData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleCollegeCheckBox = () => {
    if (collegeList === true) {
      setCollegeList(false);
    } else {
      setCollegeList(true);
    }
  };

  if (formPage === "initial")
    return (
      <>
        <br />
        <br />
        {!confirmationComponentPayment && (
          <form
            className="Auth-form"
            onSubmit={handleContinuePayment}
            enctype="multipart/form-data"
          >
            <div className="Auth-form-content">
              <h3 className="Auth-form-title">Enter Payment Details</h3>
              <div className="form-group mt-3">
                <table>
                  <tr>
                    <td>
                      <label>Transaction Id</label>
                    </td>
                    <td>
                      <input
                        onChange={(e) => setTransactionId(e.target.value)}
                        value={transactionId}
                        className="form-control"
                        required
                        type="text"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Transaction Amount</label>
                    </td>
                    <td>
                      <input
                        onChange={(e) => setAmount(e.target.value)}
                        value={amount}
                        className="form-control"
                        required
                        type="number"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Date of Payment</label>
                    </td>
                    <td>
                      <input
                        onChange={(e) => setPaymentDate(e.target.value)}
                        value={paymentDate}
                        className="form-control"
                        required
                        type="date"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Proof of Payment</label>
                    </td>
                    <td>
                      <input
                        onChange={(e) =>
                          handleFileUploadForPayment(e.target.files[0])
                        }
                        className="form-control"
                        required={proofOfPayment === "" ? true : false}
                        type="file"
                      />
                      {proofOfPayment === "load" ? (
                        <div style={{ "padding-top": "5px" }}>
                          <img className="spinner_img" src={Spinner} alt="" />
                          &nbsp;&nbsp;Uploading
                        </div>
                      ) : (
                        proofOfPayment !== "" && (
                          <div style={{ "padding-top": "5px" }}>
                            <span className="file-name">
                              <img className="done_img" src={Done} alt="" />
                              &nbsp;{proofOfPayment}
                            </span>
                          </div>
                        )
                      )}
                    </td>
                  </tr>
                </table>
                <div className="d-grid gap-2 mt-3">
                  <input
                    type="submit"
                    className="btn btn-secondary"
                    value="Continue"
                  />
                </div>
                <span className="text-danger justify-content-center">
                  {loginError}
                </span>
              </div>
            </div>
          </form>
        )}
        {confirmationComponentPayment && (
          <form className="Auth-form">
            <div className="Auth-form-content">
              <h3 className="Auth-form-title">Verify Payment Details</h3>
              <div className="form-group mt-3">
                <table>
                  <tr>
                    <td>
                      <label>Transaction Id</label>
                    </td>
                    <td>
                      <input
                        value={transactionId}
                        className="form-control"
                        readOnly
                        type="text"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Transaction Amount</label>
                    </td>
                    <td>
                      <input
                        value={amount}
                        className="form-control"
                        readOnly
                        type="text"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Date of Payment</label>
                    </td>
                    <td>
                      <input
                        value={paymentDate}
                        className="form-control"
                        readOnly
                        type="date"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Proof of Payment</label>
                    </td>
                    <td>
                      <input
                        value={proofOfPayment}
                        className="form-control"
                        readOnly
                        type="text"
                      />
                    </td>
                  </tr>
                </table>
                <div className="d-grid gap-2 mt-3">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleEdit}
                  >
                    Edit
                  </button>
                </div>
                <div className="d-grid gap-2 mt-3">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleSubmitPayment}
                  >
                    Submit
                  </button>
                </div>
                <span className="text-danger justify-content-center">
                  {loginError}
                </span>
              </div>
            </div>
          </form>
        )}
      </>
    );

  if (formPage === "payment")
    return (
      <>
        <br />
        <br />
        {!confirmationComponentPersonal && (
          <form className="Auth-form" onSubmit={handleContinuePersonal}>
            <div className="Auth-form-content">
              <h3 className="Auth-form-title">Enter Personal Details</h3>
              <table>
                <tr>
                  <td>
                    <label>Name</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                      className="form-control"
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Mother Name</label>
                    <br />
                    <span className="caption">
                      In Capital, as per Pre-Ph.D Memo
                    </span>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setMotherName(e.target.value)}
                      value={motherName}
                      className="form-control"
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Father Name</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setFatherName(e.target.value)}
                      value={fatherName}
                      className="form-control"
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Social category</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setSocialCategory(e.target.value)}
                      value={socialCategory}
                      className="form-control"
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Date of Birth</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setDateOfBirth(e.target.value)}
                      className="form-control"
                      required
                      type="date"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Photo</label>
                    <br />
                    <span className="caption">Passport Size</span>
                  </td>
                  <td>
                    <input
                      onChange={(e) =>
                        handleFileUploadPersonal(e.target.files[0], "photo")
                      }
                      className="form-control"
                      type="file"
                      required={photo === "" ? true : false}
                    />
                    {photo === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      photo !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{photo}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Signature</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) =>
                        handleFileUploadPersonal(e.target.files[0], "signature")
                      }
                      className="form-control"
                      type="file"
                      required={signature === "" ? true : false}
                    />
                    {signature === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      signature !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{signature}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Email Id</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setEmailId(e.target.value)}
                      className="form-control"
                      value={emailId}
                      required
                      type="email"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Permanent Address</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setPermanentAddress(e.target.value)}
                      className="form-control"
                      value={permanentAddress}
                      required
                      type="text"
                    />
                  </td>
                </tr>
              </table>
              <div className="d-grid gap-2 mt-3">
                <input
                  type="submit"
                  className="btn btn-secondary"
                  value="Continue"
                />
              </div>
              <span className="text-danger justify-content-center">
                {loginError}
              </span>
            </div>
          </form>
        )}
        {confirmationComponentPersonal && (
          <form className="Auth-form">
            <div className="Auth-form-content">
              <h3 className="Auth-form-title">Verify Personal Details</h3>
              <table>
                <tr>
                  <td>
                    <label>Name</label>
                  </td>
                  <td>
                    <input
                      value={name}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Mother Name</label>
                  </td>
                  <td>
                    <input
                      value={motherName}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Father Name</label>
                  </td>
                  <td>
                    <input
                      value={fatherName}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Social category</label>
                  </td>
                  <td>
                    <input
                      value={socialCategory}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Date of Birth</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={dateOfBirth}
                      readOnly
                      type="date"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Photo</label>
                  </td>
                  <td>
                    <input
                      value={photo}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Signature</label>
                  </td>
                  <td>
                    <input
                      value={signature}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Email Id</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={emailId}
                      readOnly
                      type="email"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Permanent Address</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={permanentAddress}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
              </table>
              <div className="d-grid gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleEditPersonal}
                >
                  Edit
                </button>
              </div>
              <div className="d-grid gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleSubmitPersonal}
                >
                  Submit
                </button>
              </div>
              <span className="text-danger justify-content-center">
                {loginError}
              </span>
            </div>
          </form>
        )}
      </>
    );

  if (formPage === "personal")
    return (
      <>
        <br />
        <br />
        {!confirmationComponentEducational && (
          <form className="Auth-form" onSubmit={handleContinueEducational}>
            <div className="Auth-form-content">
              <h3 className="Auth-form-title">Enter Educational Details</h3>
              <table>
                <tr>
                  <td>
                    <label>Subject/Branch</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setSubject(e.target.value)}
                      value={subject}
                      className="form-control"
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>College/Instruction</label>
                  </td>
                  <td>
                      <select
                        className="Select-option form-select colleges-list"
                        type="text"
                        onChange={(e) => e.target.value!=="Others"?setCollege(e.target.value):setCollegeList(false)}
                        // value={college}
                        placeholder="Ex: University College, Kakatiya University, Warangal"
                      >
                        <option value="University College, Kakatiya University, Warangal.">
                          University College, Kakatiya University, Warangal.
                        </option>
                        <option value="Kakatiya University College of Engineering and Technology,Kakatiya University, Warangal">
                          Kakatiya University College of Engineering and
                          Technology, Kakatiya University, Warangal
                        </option>
                        <option value="University College of Pharmaucetical sciences, Kakatiya University, Warangal.">
                          University College of Pharmaucetical Sciences,
                          Kakatiya University, Warangal
                        </option>
                        <option value="University College of Physical Education, Kakatiya University, Warangal.">
                          University College of Physical Education, Kakatiya
                          University, Warangal
                        </option>
                        <option value="Indian Institute of Chemical technology, Hyderabad (IICT)">
                          Indian Institute of Chemical Technology, Hyderabad
                          (IICT)
                        </option>
                        <option value="Kakatiya Institute of Technology and Science ,Warangal (KITSW)">
                          Kakatiya Institute of Technology and Science, Warangal
                          (KITSW)
                        </option>
                        <option value="Others">
                          Others
                        </option>
                      </select>
                    {!collegeList && (
                      <input
                        className="form-control"
                        // style={{ width: "100%" }}
                        onChange={(e) => setCollege(e.target.value)}
                        type="text"
                        required
                        value={college}
                      />
                    )}
                    {/* <input
                      type="checkbox"
                      style={{ marginRight: 10 }}
                      onChange={handleCollegeCheckBox}
                    />
                    not in ths list? */}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Faculty</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setFaculty(e.target.value)}
                      value={faculty}
                      className="form-control"
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>M.A/M.Sc. M.Com./P.G</label>
                    <br />
                    <span className="caption">
                      or Its equal examination has passed
                    </span>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setDegree(e.target.value)}
                      value={degree}
                      className="form-control"
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Name of the University</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setUniversityName(e.target.value)}
                      value={universityName}
                      className="form-control"
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Month/Year of Passing</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setYearOfPassing(e.target.value)}
                      className="form-control"
                      value={yearOfPassing}
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Name of the Supervisor</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setSupervisorName(e.target.value)}
                      className="form-control"
                      value={supervisorName}
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Title of the Thesis</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setTitleOfThesis(e.target.value)}
                      className="form-control"
                      value={titleOfThesis}
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Year of Admission into Ph.D Program</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setYearOfAdmission(e.target.value)}
                      className="form-control"
                      value={yearOfAdmission}
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Pre-Phd passing Month and Year</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => setPrePhdPassMonthYear(e.target.value)}
                      className="form-control"
                      value={prePhdPassMonthYear}
                      required
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Pre-Ph.D Memo</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => prePhdMemoFile(e.target.files[0])}
                      className="form-control"
                      required={prePhdMemo === "" ? true : false}
                      type="file"
                    />
                    {prePhdMemo === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      prePhdMemo !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{prePhdMemo}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Full time/Part time</label>
                  </td>
                  <td onChange={handleFullOrPartTime.bind(this)}>
                    <input
                      type="radio"
                      name="ftime"
                      id="full-time"
                      style={{ marginRight: 10 }}
                      defaultChecked={
                        fullOrPartTime === "Full Time" ? true : false
                      }
                      value="Full Time"
                      required
                    />
                    <label for="full-time">Full Time</label>
                    <input
                      type="radio"
                      name="ftime"
                      id="part-time"
                      style={{ marginLeft: 10, marginRight: 10 }}
                      defaultChecked={
                        fullOrPartTime === "Part Time" ? true : false
                      }
                      value="Part Time"
                      required
                    />
                    <label for="part-time">Part Time</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Submitting thesis within prescribed time?</label>
                  </td>
                  <td onChange={handleWithinTime.bind(this)}>
                    <input
                      type="radio"
                      id="withintime-yes"
                      name="withintime"
                      value="Yes"
                      defaultChecked={withInTime === "Yes" ? true : false}
                      style={{ marginRight: 10 }}
                      required
                    />
                    <label for="withintime-yes">Yes</label>
                    <input
                      type="radio"
                      id="withintime-no"
                      name="withintime"
                      defaultChecked={withInTime === "No" ? true : false}
                      value="No"
                      style={{ marginLeft: 10, marginRight: 10 }}
                      required
                    />
                    <label for="withintime-no">No</label>
                  </td>
                </tr>
                {withInTime === "No" && (
                  <tr>
                    <td>
                      <label>If No, have you taken time bar permission?</label>
                    </td>
                    <td onChange={handleTakenPermission.bind(this)}>
                      <input
                        type="radio"
                        id="timebar-yes"
                        name="timebar"
                        value="Yes"
                        defaultChecked={
                          takenPermission === "Yes" ? true : false
                        }
                        style={{ marginRight: 10 }}
                        required
                      />
                      <label for="timebar-yes">Yes</label>
                      <input
                        type="radio"
                        id="timebar-no"
                        name="timebar"
                        value="No"
                        defaultChecked={takenPermission === "No" ? true : false}
                        style={{ marginLeft: 10, marginRight: 10 }}
                        required
                      />
                      <label for="timebar-no">No</label>
                    </td>
                  </tr>
                )}
                {takenPermission === "Yes" && withInTime === "No" && (
                  <tr>
                    <td>
                      <label>if Yes,Attach the order</label>
                    </td>
                    <td>
                      <input
                        onChange={(e) => permissionOrderFile(e.target.files[0])}
                        className="form-control"
                        type="file"
                        required={permissionOrder === "" ? true : false}
                      />
                      {permissionOrder === "load" ? (
                        <div style={{ "padding-top": "5px" }}>
                          <img className="spinner_img" src={Spinner} alt="" />
                          &nbsp;&nbsp;Uploading
                        </div>
                      ) : (
                        permissionOrder !== "" && (
                          <div style={{ "padding-top": "5px" }}>
                            <span className="file-name">
                              <img className="done_img" src={Done} alt="" />
                              &nbsp;{permissionOrder}
                            </span>
                          </div>
                        )
                      )}
                    </td>
                  </tr>
                )}
                
                <tr>
                  <td>
                    <label>PhD Admission Order</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => admissionOrderFile(e.target.files[0])}
                      className="form-control"
                      required={admOrder === "" ? true : false}
                      type="file"
                    />
                    {admOrder === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      admOrder !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{admOrder}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>             
                <tr>
                  <td>
                    <label>Suoervisor's Certificate</label>
                    <br />
                    <span className="caption">
                      Attested by Dean,Head and Chairperson BoS
                    </span>
                  </td>
                  <td>
                    <input
                      onChange={(e) => supervisorCertFile(e.target.files[0])}
                      className="form-control"
                      required={supervisorCert === "" ? true : false}
                      type="file"
                    />
                    {supervisorCert === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      supervisorCert !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{supervisorCert}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Joining report</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => joiningReportFile(e.target.files[0])}
                      className="form-control"
                      type="file"
                      required={joiningReport === "" ? true : false}
                    />
                    {joiningReport === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      joiningReport !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{joiningReport}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Research Paper</label>
                    <br />
                    <span className="caption">
                      Attested by the Supervisor,Head,BoS and Dean
                    </span>
                  </td>
                  <td>
                    <input
                      onChange={(e) => researchPaperFile(e.target.files[0])}
                      className="form-control"
                      type="file"
                      required={researchPaper === "" ? true : false}
                    />
                    {researchPaper === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      researchPaper !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{researchPaper}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Synopsis</label>
                    <br />
                    <span className="caption">(Soft Copy pdf)</span>
                  </td>
                  <td>
                    <input
                      onChange={(e) => synopsisFile(e.target.files[0])}
                      className="form-control"
                      type="file"
                      required={synopsis === "" ? true : false}
                    />
                    {synopsis === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      synopsis !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{synopsis}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Thesis</label>
                    <br />
                    <span className="caption">(Soft Copy pdf)</span>
                  </td>
                  <td>
                    <input
                      onChange={(e) => thesisFile(e.target.files[0])}
                      className="form-control"
                      type="file"
                      required={thesis === "" ? true : false}
                    />
                    {thesis === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      thesis !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{thesis}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Seminar-1</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => seminar1File(e.target.files[0])}
                      className="form-control"
                      type="file"
                      required={seminar1 === "" ? true : false}
                    />
                    {seminar1 === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      seminar1 !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{seminar1}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Seminar-2</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => seminar2File(e.target.files[0])}
                      className="form-control"
                      type="file"
                      required={seminar2 === "" ? true : false}
                    />
                    {seminar2 === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      seminar2 !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{seminar2}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>No Due Certificate</label>
                  </td>
                  <td>
                    <input
                      onChange={(e) => noDueFile(e.target.files[0])}
                      className="form-control"
                      type="file"
                      required={noDue === "" ? true : false}
                    />
                    {noDue === "load" ? (
                      <div style={{ "padding-top": "5px" }}>
                        <img className="spinner_img" src={Spinner} alt="" />
                        &nbsp;&nbsp;Uploading
                      </div>
                    ) : (
                      noDue !== "" && (
                        <div style={{ "padding-top": "5px" }}>
                          <span className="file-name">
                            <img className="done_img" src={Done} alt="" />
                            &nbsp;{noDue}
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
                
              </table>
              <div className="d-grid gap-2 mt-3">
                <input
                  type="submit"
                  className="btn btn-secondary"
                  value="Continue"
                />
              </div>
            </div>
          </form>
        )}
        {confirmationComponentEducational && (
          <form className="Auth-form">
            <div className="Auth-form-content">
              <h3 className="Auth-form-title">Verify Educational Details</h3>
              <table>
                <tr>
                  <td>
                    <label>Subject/Branch</label>
                  </td>
                  <td>
                    <input
                      value={subject}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>College/Instruction</label>
                  </td>
                  <td>
                    <input
                      value={college}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Faculty</label>
                  </td>
                  <td>
                    <input
                      value={faculty}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>M.A/M.Sc. M.Com./P.G</label>
                  </td>
                  <td>
                    <input
                      value={degree}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Name of the University</label>
                  </td>
                  <td>
                    <input
                      value={universityName}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Month/Year of Passing</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={yearOfPassing}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Name of the Supervisor</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={supervisorName}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Year of Admission into Ph.D Program</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={yearOfAdmission}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Title of the Thesis</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={titleOfThesis}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Year of Admission into Ph.D Program</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={yearOfAdmission}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Full time/Part time</label>
                  </td>
                  <td>{fullOrPartTime}</td>
                </tr>
                <tr>
                  <td>
                    <label>Submitting thesis within prescribed time?</label>
                  </td>
                  <td>{withInTime}</td>
                </tr>
                {withInTime === "No" && (
                  <tr>
                    <td>
                      <label>If No, have you taken time bar permission?</label>
                    </td>
                    <td>{takenPermission}</td>
                  </tr>
                )}
                {takenPermission === "Yes" && withInTime === "No" && (
                  <tr>
                    <td>
                      <label>if Yes,Attach the order</label>
                    </td>
                    <td>
                      <input
                        value={permissionOrder}
                        className="form-control"
                        readOnly
                        type="text"
                      />
                    </td>
                  </tr>
                )}
                <tr>
                  <td>
                    <label>Title of the Thesis</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={titleOfThesis}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                
                <tr>
                  <td>
                    <label>PhD Admission Order</label>
                  </td>
                  <td>
                    <input
                      value={admOrder}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Suoervisor's Certificate</label>
                  </td>
                  <td>
                    <input
                      value={supervisorCert}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Joining report</label>
                  </td>
                  <td>
                    <input
                      value={joiningReport}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Research Paper</label>
                  </td>
                  <td>
                    <input
                      value={researchPaper}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Synopsis</label>
                  </td>
                  <td>
                    <input
                      value={synopsis}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Thesis</label>
                  </td>
                  <td>
                    <input
                      value={thesis}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Seminar-1</label>
                  </td>
                  <td>
                    <input
                      value={seminar1}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Seminar-2</label>
                  </td>
                  <td>
                    <input
                      value={seminar2}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>No Due Certificate</label>
                  </td>
                  <td>
                    <input
                      readOnly
                      value={noDue}
                      className="form-control"
                      type="text"
                    />
                  </td>
                </tr>
                
              </table>
              <div className="d-grid gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleEditEducational}
                >
                  Edit
                </button>
              </div>
              <div className="d-grid gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleSubmitEducational}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        )}
      </>
    );
}
export default ApplicationForm;

function logout() {
  window.localStorage.clear();
  Cookies.remove("userInfo");
  Cookies.remove("username");
  window.location.href = "/";
}
